import type {
  TAppointmentCamel,
  TAppointmentCanaryAssessment,
} from '../appointments';
import type { TActionEventCamel, TChatDataCamel } from '../chats';
import type { TVitalsCamel } from '../medwand';
import type { TNotificationCamel } from '../notifications';
import type { TUserDataCamel } from '../user';

export enum ESocketListenMessageType {
  NOTIFICATION = 'notification',
  ON_DEMAND_UPDATED = 'on_demand:updated',
  APPOINTMENT = 'appointment',
  CHAT_UPDATED = 'chat:updated',
  WAITING_ROOM_UPDATED = 'waiting_room:updated',
  ACTION = 'action',
  USER = 'user',

  CANARY_RESULT = 'canary:results',
  VITALS = 'vitals',
}

interface ISocketListenMessageTemplate<T extends ESocketListenMessageType, B> {
  type: T;
  callback: (message: B) => void;
}

// ***************SOCKET LISTEN MESSAGE NOTIFICATION***************

type TSocketListenMessageNotification = ISocketListenMessageTemplate<
  ESocketListenMessageType.NOTIFICATION,
  TNotificationCamel
>;

// ***************END SOCKET LISTEN MESSAGE NOTIFICATION***************

// ***************SOCKET LISTEN MESSAGE ON_DEMAND***************
interface ISocketListenMessageAppointmentBody {
  appointment: TAppointmentCamel;
  user: TUserDataCamel;
}

type TSocketListenMessageAppointmentUpdated = ISocketListenMessageTemplate<
  ESocketListenMessageType.ON_DEMAND_UPDATED,
  Pick<ISocketListenMessageAppointmentBody, 'appointment'>
>;

// ***************END SOCKET LISTEN MESSAGE ON_DEMAND***************

// *************** SOCKET LISTEN MESSAGE APPOINTMENT ***************

// WORKING WHEN sendMessage firehose:start
type TSocketListenMessageAppointment = ISocketListenMessageTemplate<
  ESocketListenMessageType.APPOINTMENT,
  { appointment: TAppointmentCamel }
>;

// *************** END SOCKET LISTEN MESSAGE APPOINTMENT ***************

// *************** SOCKET LISTEN MESSAGE ACTION_EVENT ***************

// WORKING WHEN sendMessage firehose:start

type TSocketListenMessageActionEvent = ISocketListenMessageTemplate<
  ESocketListenMessageType.ACTION,
  { action: TActionEventCamel }
>;

// *************** END SOCKET LISTEN MESSAGE ACTION_EVENT ***************

// *************** SOCKET LISTEN MESSAGE CHAT_UPDATE ***************
type TSocketListenMessageChatUpdate = ISocketListenMessageTemplate<
  ESocketListenMessageType.CHAT_UPDATED,
  { chat: TChatDataCamel }
>;

// *************** END SOCKET LISTEN MESSAGE CHAT_UPDATE ***************

// WORKING WHEN sendMessage firehose:start
type TSocketListenMessageWaitingRoom = ISocketListenMessageTemplate<
  ESocketListenMessageType.WAITING_ROOM_UPDATED,
  { appointment: TAppointmentCamel }
>;

// *************** END SOCKET LISTEN MESSAGE APPOINTMENT ***************

// *************** SOCKET LISTEN MESSAGE CANARY ***************

type TSocketListenMessageCanaryResult = ISocketListenMessageTemplate<
  ESocketListenMessageType.CANARY_RESULT,
  { result: TAppointmentCanaryAssessment }
>;

// *************** END SOCKET LISTEN MESSAGE CANARY ***************

// *************** SOCKET LISTEN MESSAGE USER ***************

type TSocketListenMessageUser = ISocketListenMessageTemplate<
  ESocketListenMessageType.USER,
  { user: TUserDataCamel }
>;

// *************** END SOCKET LISTEN MESSAGE USER ***************

// *************** SOCKET LISTEN MESSAGE VITALS ***************

// WORKING WHEN sendMessage firehose:start
type TSocketListenMessageVitals = ISocketListenMessageTemplate<
  ESocketListenMessageType.VITALS,
  { vitals: TVitalsCamel }
>;

// *************** END SOCKET LISTEN MESSAGE VITALS ***************

// Add other SocketListenMessage
export type TSocketListenMessageCamel =
  | TSocketListenMessageNotification
  | TSocketListenMessageAppointmentUpdated
  | TSocketListenMessageAppointment
  | TSocketListenMessageChatUpdate
  | TSocketListenMessageActionEvent
  | TSocketListenMessageWaitingRoom
  | TSocketListenMessageCanaryResult
  | TSocketListenMessageUser
  | TSocketListenMessageVitals;
